import React, { useState } from 'react'
import { Empty, Pagination } from 'antd'
import { MoreOutlined, RightOutlined } from '@ant-design/icons'
import styles from './bridge.module.css'
import { PAGE_SIZE } from './useBridgeList'
import PageLoading from '../../UI/status/loading'

export default function BridgeTable({
  columns,
  dataSource,
  rowKey = 'id',
  loading,
  emptyText,
  renderExpanded,
  showKebab = false,
  count = 0,
  page = 1,
  onPageChange
}) {
  const [expandedKeys, setExpandedKeys] = useState([])

  const toggleRow = (key) => {
    setExpandedKeys((keys) =>
      keys.includes(key) ? keys.filter((k) => k !== key) : [...keys, key]
    )
  }

  const rows = loading ? [] : dataSource || []
  const colCount = columns.length + 1 + (showKebab ? 1 : 0)

  return (
    <div>
      <table className={styles.bridgeTable}>
        <thead>
          <tr>
            {renderExpanded && <th className={styles.expandCol} />}
            {columns.map((col) => (
              <th
                key={col.key || col.dataIndex}
                style={{ width: col.width }}
                className={col.align === 'right' ? styles.thRight : undefined}
              >
                {col.title}
              </th>
            ))}
            {showKebab && <th className={styles.expandCol} />}
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={colCount} className={styles.centerCell}>
                <PageLoading style={{ color: '#4C6072' }} />
              </td>
            </tr>
          )}
          {!loading && rows.length === 0 && (
            <tr>
              <td colSpan={colCount} className={styles.centerCell}>
                <Empty description={emptyText || 'No data'} />
              </td>
            </tr>
          )}
          {!loading &&
            rows.map((record) => {
              const key = String(record[rowKey])
              const isExpanded = expandedKeys.includes(key)
              return (
                <React.Fragment key={key}>
                  <tr className={styles.row}>
                    {renderExpanded && (
                      <td className={styles.expandCol}>
                        <span
                          className={`${styles.chevron} ${isExpanded ? styles.chevronOpen : ''}`}
                          onClick={() => toggleRow(key)}
                        >
                          <RightOutlined />
                        </span>
                      </td>
                    )}
                    {columns.map((col) => (
                      <td
                        key={col.key || col.dataIndex}
                        className={col.align === 'right' ? styles.tdRight : undefined}
                      >
                        {col.render
                          ? col.render(record[col.dataIndex], record)
                          : record[col.dataIndex] == null
                            ? '—'
                            : record[col.dataIndex]}
                      </td>
                    ))}
                    {showKebab && (
                      <td className={styles.expandCol}>
                        <MoreOutlined className={styles.kebab} />
                      </td>
                    )}
                  </tr>
                  {renderExpanded && isExpanded && (
                    <tr className={styles.expandedRow}>
                      <td colSpan={colCount}>{renderExpanded(record)}</td>
                    </tr>
                  )}
                </React.Fragment>
              )
            })}
        </tbody>
      </table>
      <div className={styles.paginationBar}>
        <span className={styles.muted}>Total {count} records</span>
        <Pagination
          size="small"
          current={page}
          pageSize={PAGE_SIZE}
          total={count}
          onChange={onPageChange}
        />
      </div>
    </div>
  )
}
